module.exports = __webpack_public_path__ + "img/search.2bd5fca0.svg";